export const GET_GENERAL_MERCHANT_INFOS = "GET_GENERAL_MERCHANT_INFOS"
export const GET_GENERAL_MERCHANT_INFOS_ERR = "GET_GENERAL_MERCHANT_INFOS_ERR"

export const RESET_GENERAL_MERCHANT_INFOS = "RESET_GENERAL_MERCHANT_INFOS"